// ----------------------------------------------------------------------------
// Component: Scroll To
// - Scroll to an anchor tag
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

var ANCHOR_SELECTOR = 'a.button[href*="#"]:not([href="#"])';
var STICKY_SELECTOR = '.sticky';

module.exports = function() {

    if (window.location.hash) {
        scroll_to.target(window.location.hash);
    }

    $(document).on('click', ANCHOR_SELECTOR,  _.bind(scroll_to.click, scroll_to));
};

var scroll_to = {

    click: function(e) {
        e.preventDefault();

        var $link = $(e.target),
            id = $link.attr('href');

        // scroll to target
        this.target(id);
    },

    target: function(id) {
        var $anchor = this.parseTarget(id);
        var stickyHeight = 0;

        if (!$anchor || $anchor.length === 0) { return false; }

        // Account for sticky header, hello-bar, etc.
        $(STICKY_SELECTOR).each(function() {
            var elemHeight = $(this).is(':visible') ? $(this).outerHeight() : 0;

            stickyHeight+= elemHeight;
        });

        $('html, body').animate({
            scrollTop: $anchor.offset().top - stickyHeight
        }, 1000);

        return false;
    },

    parseTarget: function(id) {
        if (typeof id === 'undefined') {
            return false;
        }
        else if (id instanceof jQuery) {
            $anchor = id;
        }
        else if ('#' === id.charAt(0)) {
            id = id.substr(1);

            $anchor = $('#' + id.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&'));

            if (!$anchor.length) {
                $anchor = $('a[name="'+id+'"]');
            }
        }

        return $anchor;
    }

};
